import * as TypeGraphQL from "type-graphql";
export var TradeStrategy;
(function (TradeStrategy) {
    TradeStrategy["TECHNICAL_ANALYSIS"] = "TECHNICAL_ANALYSIS";
    TradeStrategy["TREND_FOLLOWING"] = "TREND_FOLLOWING";
    TradeStrategy["MEAN_REVERSION"] = "MEAN_REVERSION";
    TradeStrategy["MOMENTUM_STRATEGY"] = "MOMENTUM_STRATEGY";
    TradeStrategy["NEWS_BASED_STRATEGY"] = "NEWS_BASED_STRATEGY";
    TradeStrategy["SCALPING"] = "SCALPING";
    TradeStrategy["VOLATILITY_TRADING"] = "VOLATILITY_TRADING";
    TradeStrategy["EVENT_DRIVEN"] = "EVENT_DRIVEN";
    TradeStrategy["BREAKOUT_STRATEGY"] = "BREAKOUT_STRATEGY";
    TradeStrategy["ORDER_FLOW_TRADING"] = "ORDER_FLOW_TRADING";
    TradeStrategy["OPTIONS_SPREAD"] = "OPTIONS_SPREAD";
    TradeStrategy["NO_STRATEGY"] = "NO_STRATEGY";
})(TradeStrategy || (TradeStrategy = {}));
TypeGraphQL.registerEnumType(TradeStrategy, {
    name: "TradeStrategy",
    description: undefined,
});
//# sourceMappingURL=TradeStrategy.js.map